import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';



export const configSections = {
    // USUARIO
    USER_PROFILE: "perfil-de-usuario",                  // Perfil de Usuario
    PASSWORD_CHANGE: "cambio-de-contraseña",            // Cambio de Contraseña
    PLATFORM_INFO: "informacion-de-plataforma",         // informacion dle usuario en la plataforma

    // CONFIGURACION
    ICONS_CONFIGURATION: "configuracion-de-iconos",      // Configuración de Iconos
    LENGUAGE_CONFIGURATION: "configuracion-de-idioma",   // Configuración de Idiomas

    // PREFERENCIAS
    THEME_CUSTOM: "personalizacion-de-thema",           // Personalizacion del theme
    VIEWS_PREFERENCES: "preferencias-de-vista",         // Mostrar o ocultar paneles

    // CONFIGURACIONES DE MODULOS
    VEHICLE_CONFIG: "configuracion_vehicle",
    ALERT_CONFIG: "alerta_configuracion",
    GEOFENCE_CONFIG : "geocercas_configuracion",
    GEOPOINTS_CONFIG : "geopoints_configuracion",
    EVENTS_CONFIG : "eventos_configuracion",
    DRIVERS_CONFIG : "conductores_configuracion",
    FOOTBAR_CONFIG : "footbar_configuracion",
    HISTORY_CONFIG : "historial_configuracion",
    CARD_VEHICLES: 'tarjeta-de-vehiculos', // Tarjeta de Vehículos
    HISTORY_DRAWER_CONFIGURATION: 'configuracion-de-historial', // Configuración de Historial Dinámico
  };

@Injectable({
  providedIn: 'root'
})
export class UserConfigPanelService {
  private sectionConfigSelected = new BehaviorSubject<string>(configSections.USER_PROFILE);
  sectionConfigSelected$: Observable<string> = this.sectionConfigSelected.asObservable();

  constructor() { }

  getSelectedSection(): string {
    return this.sectionConfigSelected.getValue();
  }

  setSelectedSection(section: string): void {
    this.sectionConfigSelected.next(section);
  }

}
